/* global google */
// Define the callback globally before Google Maps API loads
window.initPropelMaps = function () {
	const maps = document.querySelectorAll('.block-map__canvas');

	if (!maps.length) return;

	maps.forEach((mapEl) => {
		// Skip if already initialized
		if (mapEl.dataset.initialized) return;

		const markersData = JSON.parse(mapEl.dataset.markers || '[]');
		const defaultZoom = parseInt(mapEl.dataset.zoom, 10) || 14;
		const pinUrl = mapEl.dataset.pinUrl || '';

		if (!markersData.length) return;

		// Calculate bounds to fit all markers
		const bounds = new google.maps.LatLngBounds();
		markersData.forEach((marker) => {
			bounds.extend({
				lat: parseFloat(marker.lat),
				lng: parseFloat(marker.lng),
			});
		});

		// Use first marker as center if only one, otherwise use bounds center
		const center =
			markersData.length === 1
				? {
						lat: parseFloat(markersData[0].lat),
						lng: parseFloat(markersData[0].lng),
					}
				: bounds.getCenter();

		const map = new google.maps.Map(mapEl, {
			center,
			zoom: defaultZoom,
			mapTypeControl: false,
			streetViewControl: false,
			fullscreenControl: false,
		});

		// Fit bounds if multiple markers
		if (markersData.length > 1) {
			map.fitBounds(bounds);
		}

		// Create markers
		markersData.forEach((markerData) => {
			const lat = parseFloat(markerData.lat);
			const lng = parseFloat(markerData.lng);
			const address = markerData.address || '';
			const locationName = markerData.name || '';

			if (isNaN(lat) || isNaN(lng)) return;

			const markerOptions = {
				position: { lat, lng },
				map,
			};

			// Use custom pin icon if provided (multiple markers)
			if (pinUrl) {
				markerOptions.icon = {
					url: pinUrl,
					scaledSize: new google.maps.Size(40, 40),
				};
			}

			const marker = new google.maps.Marker(markerOptions);

			// Create info window content
			const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
			let infoContent = '<div class="block-map__info-window">';

			if (locationName) {
				infoContent += `<strong class="block-map__info-name">${locationName}</strong>`;
			}

			if (address) {
				infoContent += `<p class="block-map__info-address">${address}</p>`;
			}

			infoContent += `<a class="block-map__info-link" href="${googleMapsUrl}" target="_blank" rel="noopener noreferrer">View larger map</a>`;
			infoContent += '</div>';

			const infoWindow = new google.maps.InfoWindow({
				content: infoContent,
			});

			// Only open info window on marker click
			marker.addListener('click', () => {
				infoWindow.open(map, marker);
			});
		});

		mapEl.dataset.initialized = 'true';
	});
};
